import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getPPHIDetail, payNow } from "../service/pphi";
import {PPHIcheckBOX, PPHIMessageBox} from "../../../assets/img/svg";
import "./pphi.scss"; // Assuming you have a CSS file for styling
import Loader from "./Loader";
import InvalidPage from "./InvalidPage";
import HeaderPPHI from "./HeaderPPHI";
import PPHIResult from "./PPHIResult";
import PPHICollect from "./PPHICollect";
import PPHIAppDetail from "./PPHIAppDetail";

const PPHI = () => {
  let { enc_data } = useParams();
  let [load, setLoad] = useState(true);
  const [ppphiData, setPphiData] = useState({});
  const [orderData, setOrderData] = useState({});
  const [paymentData, setPaymentData] = useState({});
  const [isPayButtonDisabled, setIsPayButtonDisabled] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const atp_status = queryParams.get("atp_status") || null;

  useEffect(() => {
    getPPHIDetail(enc_data, setPphiData, setPaymentData, setOrderData, setLoad);
  }, []);

  const handlePaynow = () => {
    payNow(enc_data, paymentData);
  };

  const handlePPHIRetry = () => {
    const cleanUrl = window.location.href.split("?")[0];
    window.location.replace(cleanUrl, "_blank");
  };

  const PPHIRetry = () => {
    window.location.reload();
  };

  return (
    <div>
      <div className="campaign_payment">
        <div className="page_wrapper">
          <HeaderPPHI />
          {load ? (
            <Loader />
          ) : (
            <div>
              {orderData.status == "INVALID" ? (
                <InvalidPage PPHIRetry={PPHIRetry} orderData={orderData} />
              ) : (
                <div className="payment-container">
                  <div className="name-wrapper">
                    <div className="left-content">
                      <h3>Welcome,</h3>
                      <h5>{ppphiData.name}</h5>
                    </div>
                    <div className="right-content">
                      {(orderData.page == "collect" && atp_status === null) && (
                        <div className="d-flex align-items-center gap-2">
                          <p className="success-text text-start text-md-left pphi-text">
                            {" "}
                            <PPHIcheckBOX /> Your Application has been
                            successfully approved. Proceed to complete your
                            payment.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="details-wrapper pphi-details-wrapper">
                    <div className="details-header details-header-pphi flex justify-between items-center">
                      <div>
                        <h3>Payment Summary</h3>
                      </div>
                      <div>
                        <h3>
                          ₹
                          {(
                            ppphiData.paid_amount + ppphiData.amount
                          ).toLocaleString("en-IN")}
                        </h3>
                      </div>
                    </div>
                    <div className="details-content p-4">
                      {(orderData.page == "collect" && atp_status === null) ? (
                        <PPHICollect
                          enc_data={enc_data}
                          ppphiData={ppphiData}
                          orderData={orderData}
                          isPayButtonDisabled={isPayButtonDisabled}
                          handlePaynow={handlePaynow}
                          setIsPayButtonDisabled={setIsPayButtonDisabled}
                        />
                      ) : (
                        <PPHIResult
                          orderData={orderData}
                          ppphiData={ppphiData}
                          handlePPHIRetry={handlePPHIRetry}
                        />
                      )}
                    </div>
                  </div>
                  {
                    (orderData.page == "collect" && atp_status === null) && (
                    <div className="pphi-message-wrapper display-flex  align-items-end row">
                      <div className="text-md-left pphi-text">
                        {" "}
                        <PPHIMessageBox /> To pay offline using a cheque or
                        demand draft, please contact your agent for assistance.
                      </div>
                    </div>)
                  }

                  {(orderData.page == "collect" && atp_status === null) && <PPHIAppDetail ppphiData={ppphiData} />}

                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PPHI;
